import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import * as Integrations from '@sentry/integrations';
import * as Sentry from '@sentry/browser';
import App from '@/App.vue';
import i18n from '@/i18n';
import router from '@/router';
import store from '@/store';
import config from '@/config';

const isInProductionEnvironment = process.env.NODE_ENV === 'production';

if (isInProductionEnvironment) {
  Sentry.init({
    dsn: config.sentryDsn,
    integrations: [new Integrations.Vue({
      Vue,
      attachProps: true,
    })],
  });
}

Vue.config.productionTip = false;

Vue.use(VueScrollTo);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
